import { render } from "./AddInventory.vue?vue&type=template&id=0ddf3060"
import script from "./AddInventory.vue?vue&type=script&lang=js"
export * from "./AddInventory.vue?vue&type=script&lang=js"
script.render = render

export default script